import { modeModel } from "../../model/ModeModel";
import { createTheme } from "@mui/material/styles";
import getLPTheme from "./getLPTheme";

function createLPTheme() {
    const { mode } = modeModel;
    return createTheme(getLPTheme(mode));    
}

function createDefaultTheme() {
    const { mode } = modeModel;
    return createTheme({ palette: { mode } });
}

export function getTheme() {
    const { showCustomTheme } = modeModel;
    return showCustomTheme ? createLPTheme() : createDefaultTheme();
}
